import React from "react";
import { Navigate, Route, RouteProps } from "react-router";
import { useAuth } from "../../auth/contexts/AuthProvider";
import { getUser } from "../../admin/infra/getUser";
import Loader from "./Loader";

const BASE = process.env.PUBLIC_URL || "";

type PrivateRouteProps = {
  roles?: string[];
  element?: React.ReactNode;
} & RouteProps;

const PrivateRoute = ({
  children,
  roles,
  element,
  ...routeProps
}: PrivateRouteProps) => {
  const { hasRole, userInfo, sessionReady, isAuthenticated } = useAuth();

  if (!sessionReady) {
    return <Loader />;
  }

  if (!isAuthenticated || !userInfo) {
    return <Navigate to={`${BASE}/login`} replace />;
  }
  if (!hasRole(roles)) {
    return <Navigate to={`${BASE}/403`} replace />;
  }
  const cf = getUser().cf;
  const cadastroIncompleto = cf !== "1";
  if (cadastroIncompleto) {
    if (window.location.pathname.includes("/cadastro")) {
      if (element) return <>{element}</>;
      return <Route {...routeProps} />;
    }
    return <Navigate to={`${BASE}/candidato/cadastro`} replace />;
  }
  if (element) {
    return <>{element}</>;
  }
  return <Route {...routeProps} />;
};

export default PrivateRoute;
